import { render, staticRenderFns } from "./a_AboutUs.vue?vue&type=template&id=8522e7da&scoped=true&"
import script from "./a_AboutUs.vue?vue&type=script&lang=js&"
export * from "./a_AboutUs.vue?vue&type=script&lang=js&"
import style0 from "./a_AboutUs.vue?vue&type=style&index=0&id=8522e7da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8522e7da",
  null
  
)

export default component.exports